import { CreateMarkdownComponent } from '@revert/markdown'
import { PrimitiveBackground } from '../background'
import { PrimitiveBorder } from '../border'
import { PrimitiveText } from '../text'

export const Markdown = CreateMarkdownComponent({
  PrimitiveBackground,
  PrimitiveBorder,
  PrimitiveText,
})
